import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function AttributeEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function AttributeCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"attribute"} children={children} />
    );
}